<template>
<div class='top'>

  <div class="flex flex-direction align-center  justify-center width margin-center">
    <img src="../assets/img/logo.png" style="width:203px;height:46px;margin-top:46px" />
    <div class="flex-relative justify-center" style="   margin-top: 17px;height: 38px ;width: 100%;">
      <input type="text" class="input" v-model="search" @keyup.enter="clickInput" placeholder="请输入关键词...">
      <button class="button" @click="clickInput"> <img src="../assets/img/search.png" alt=""></button>
      <div style="position: absolute;right:0px;bottom:0px" v-if="userBase == null" class=" flex font-color-black font-size-14">
        <p class="font-color-black font-size-14" style="text-decoration:none;cursor: pointer;" @click="login">登录</p>
        &nbsp;&nbsp;/&nbsp;&nbsp;
        <p class="font-color-black font-size-14" style="text-decoration:none;cursor: pointer;" @click="register">注册</p>

      </div>
      <div v-else style="position: absolute;right:0px;bottom:0px" class="flex-relative font-color-black font-size-14">
        <div class="flex" v-if="userBase.UserType == 0">
          <p class="font-color-black font-size-14" style="text-decoration:none;">{{userBase.UserName}} </p>

          <p v-if="userBase.ComCode!=='hngydx'" class="font-color-black font-size-14" style="text-decoration:none;cursor: pointer;" @click="login">&nbsp;&nbsp;/&nbsp;&nbsp;登录&nbsp;&nbsp;/&nbsp;&nbsp;</p>

          <p v-if="userBase.ComCode!=='hngydx'" class="font-color-black font-size-14" style="text-decoration:none;cursor: pointer;" @click="register">注册</p>
        </div>
        <!-- <div class="flex" v-else-if="userBase.UserType == 4">
          <p class="font-color-black font-size-14" style="text-decoration:none;">{{userBase.UserName}} </p>
          &nbsp;&nbsp;/&nbsp;&nbsp;
          <p class="font-color-black font-size-14" style="text-decoration:none;cursor: pointer;" @click="login">登录</p>
          &nbsp;&nbsp;/&nbsp;&nbsp;
          <p class="font-color-black font-size-14" style="text-decoration:none;cursor: pointer;" @click="register">注册</p>
        </div> -->
        <div class="flex" v-else>
          <p class="font-color-black font-size-14" style="text-decoration:none;cursor: pointer;">{{userBase.UserName}}</p>
          &nbsp;&nbsp;/&nbsp;&nbsp;
          <p class="font-color-black font-size-14" style="text-decoration:none;cursor: pointer;" @click="loginOut">退出</p>
        </div>
      </div>
    </div>

  </div>
</div>
<!-- <div class="bg-white">
    <div class="flex align-center  justify-between width margin-center"
         style="height:80px">
      <img src="../assets/img/logo.jpg" />

    </div>

  </div> -->
</template>

<script>
// const userName = false;
import common from '../utils/common'
import { removeToken } from '@/utils/auth'
export default {
  data () {
    return {
      // userBase: null,
      userBase: common.userBase,
      search: ''
    }
  },
  beforeMount () {
    // this.getHeadToken();

    // this.getToken();
    this.isToken()
  },

  methods: {
    isToken () {
      // var token = localStorage.getItem('is_Token') || '';
      var token = common.getCookie('utoken')
      if (token !== '') {
        this.loginData(token)
      }
      localStorage.removeItem('islogin_httpurl')
    },

    clickInput () {
      if (this.search === '') {

      } else {
        if (window.location.href.indexOf('/search') != -1) {
          this.$emit('getShopCode', this.search)
          this.$router.replace({
            path: '/search',
            query: {
              'key': this.search
            }
          })
        } else {
          this.$router.push({
            path: '/search',
            query: {
              'key': this.search
            }
          })
        }
      }
    },

    loginData (token) {
      var that = this
      this.getRequest('api/v1/login', {
        token: token
      }).then(data => {
        if (data.IsSuccess) {
          that.userBase = data.Data
          common.userBase = data.Data

          this.$store.dispatch('user/login', data.Data)
        } else {
          // localStorage.removeItem("is_Token");
          this.userBase = null
          common.userBase = null

          // this.$router.go(0)
          that.loginOut()
        }
      })
    },
    login () {
      localStorage.setItem('islogin_httpurl', window.location.href)
      this.$router.replace({
        name: 'black',
        params: {
          isfirst: 'first',
          states: 'login'
        }
      })
    },

    register () {
      localStorage.setItem('islogin_httpurl', window.location.href)
      this.$router.replace({
        name: 'black',
        params: {
          isfirst: 'first',
          states: 'reigist'
        }
      })
    },

    loginOut () {
      this.userBase = null
      common.userBase = null

      this.$store.dispatch('user/logout')
      removeToken()
      // localStorage.removeItem("is_Token");

      // var http = common.httploginout + encodeURI(window.location.href)
      // window.open(http, '_self')
    }
  }
}
</script>

<style scoped>
p:hover {
  color: #d30000;
}

.top {
  background-image: url(../assets/img/head.png);
  background-position: center;
  height: 190px;
  width: 100%;
}

.input {
  width: 332px;
  height: 38px;
  background: #ffffff;
  border: 0;
  margin-top: 0px;
  outline: 0;
  border: solid 1px #eeeeee;
  padding: 0 10px;
}

.button {
  width: 42px;
  height: 38px;

  border: 1px solid #eeeeee;
  outline: none;
  background: linear-gradient(#f7f7f7 0%, #ffffff 100%);
  /* background-image: url(../assets/img/search.png);
  background-position: center; */
  cursor: pointer;
  /* background-repeat: no-repeat; */
}

.button:focus {
  outline: none;
}

.button:active {
  transform: translateY(1px);
}
</style>



// WEBPACK FOOTER //
// src/components/head.vue